import React, { useEffect, useRef } from 'react';
import testimonialsConfig from '../config/testimonials.json';

const Testimonials: React.FC = () => {
  const { testimonials } = testimonialsConfig;
  const containerRef = useRef<HTMLDivElement>(null);

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i
        key={index}
        className={`fas fa-star ${index < rating ? 'active' : ''}`}
      ></i>
    ));
  };

  const checkTruncation = (element: HTMLElement, fullText: string) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return false;

    const computedStyle = window.getComputedStyle(element);
    context.font = `${computedStyle.fontWeight} ${computedStyle.fontSize} ${computedStyle.fontFamily}`;
    
    const textWidth = context.measureText(fullText).width;
    const elementWidth = element.offsetWidth;
    
    return textWidth > elementWidth;
  };

  useEffect(() => {
    if (!containerRef.current) return;

    const authorNames = containerRef.current.querySelectorAll('.author-name');
    const authorMetas = containerRef.current.querySelectorAll('.author-meta');

    authorNames.forEach((element) => {
      const htmlElement = element as HTMLElement;
      const fullText = htmlElement.textContent || '';
      if (checkTruncation(htmlElement, fullText)) {
        htmlElement.setAttribute('data-truncated', 'true');
        htmlElement.setAttribute('data-full-text', fullText);
      }
    });

    authorMetas.forEach((element) => {
      const htmlElement = element as HTMLElement;
      const fullText = htmlElement.textContent || '';
      if (checkTruncation(htmlElement, fullText)) {
        htmlElement.setAttribute('data-truncated', 'true');
        htmlElement.setAttribute('data-full-text', fullText);
      }
    });
  }, [testimonials]);

  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">What Our Customers Say</h2>
          <p className="section-description">
            Trusted by thousands of businesses worldwide
          </p>
        </div>
        
        <div className="testimonials-container" ref={containerRef}>
          <div className="testimonials-track">
            {/* First set of testimonials */}
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-header">
                  <div className="author-avatar">
                    <img 
                      src={testimonial.avatar} 
                      alt={testimonial.name}
                    />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">{testimonial.name}</h4>
                    <p className="author-meta">{testimonial.position} • {testimonial.company}</p>
                  </div>
                  <div className="testimonial-rating">
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "{testimonial.comment}"
                  </p>
                </div>
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {testimonials.map((testimonial) => (
              <div key={`${testimonial.id}-duplicate`} className="testimonial-card">
                <div className="testimonial-header">
                  <div className="author-avatar">
                    <img 
                      src={testimonial.avatar} 
                      alt={testimonial.name}
                    />
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">{testimonial.name}</h4>
                    <p className="author-meta">{testimonial.position} • {testimonial.company}</p>
                  </div>
                  <div className="testimonial-rating">
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
                <div className="testimonial-content">
                  <p className="testimonial-text">
                    "{testimonial.comment}"
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 